<template>
  <div>
    <protocoloProcessoComponenteVue :detalhe="detalhe" :modal="false" />
  </div>
</template>
<script>
import protocoloService from "@/services/processos-eletronicos/protocoloService";
import protocoloProcessoComponenteVue from "@/components/processo-eletronico/protocolo-processo-componente.vue";
import { UtilsTS } from "@/utilsts";

export default {
  name: "DetalheProtocoloProcesso",
  components: {
    protocoloProcessoComponenteVue,
  },
  mixins: [UtilsTS],
  data() {
    return {
      detalhe: {},
      tableMovimentacoes: {
        perPage: 10,
        currentPage: 1,
        totalRows: 0,
      },
    };
  },
  computed: {},
  async mounted() {
    this.loadDetalheProtocoloProcesso(this.$route.params.item);
  },
  methods: {
    checkProperties(obj) {
      let check = {};
      for (var key in obj) {
        if (!Array.isArray(obj[key]) && (obj[key] == null || obj[key] == ""))
          check[key] = "Não disponível";
        else check[key] = obj[key];
      }
      return check;
    },

    async loadDetalheProtocoloProcesso(item) {
      try {
        let response = await protocoloService.carregarDetalheProtocoloProcesso(
          item
        );
        if (response && response.status === 200) {
          this.detalhe = this.checkProperties(response.data);
          this.detalhe.Relacionamentos.filter((f) => {
            return (
              f.TipoRelacionamento == "Juntada" ||
              f.TipoRelacionamento == "Apensamento"
            );
          });
          this.detalhe.cancelado = this.$route.params.cancelado;
          this.tableMovimentacoes.totalRows = this.detalhe.Movimentacoes.length;
        } else {
          throw new Error(
            response.data && response.data.msg
              ? response.data.msg
              : "Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!"
          );
        }
      } catch (e) {
        console.error(e);
        this.$toast.error(e.message ? e.message : e);
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
<style></style>